"use client";

import { useState } from "react";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Projects() {
  const filters = ["Wszystkie Realizacje", "Dachy Płaskie", "Dachy Skośne", "Hydroizolacja Tarasów", "Obiekty Przemysłowe", "Renowacje"];
  const [activeFilter, setActiveFilter] = useState("Wszystkie Realizacje");
  const projects = [{
    number: "HR-018",
    name: "Hydroizolacja dachu płaskiego",
    room: "Dachy Płaskie",
    location: "Pszczyna",
    year: "2024",
    span: "col-span-12 md:col-span-7",
    aspect: "aspect-[4/3]",
    image: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5850-scaled.jpeg?v=ily2vy7fei",
    srcset: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5850-scaled.jpeg?v=5ie7ti56n39-wvc-srcset",
    sizes: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5850-scaled.jpeg?v=jlf0ekoszv9-wvc-sizes"
  }, {
    number: "HR-019",
    name: "Renowacja papy bitumicznej",
    room: "Renowacje",
    location: "Śląsk",
    year: "2024",
    span: "col-span-12 md:col-span-5",
    aspect: "aspect-[3/4]",
    image: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5817-scaled.jpeg?v=uz7akvkwgj",
    srcset: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5817-scaled.jpeg?v=adzj7mpcwdg-wvc-srcset",
    sizes: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5817-scaled.jpeg?v=5qy18vai0ig-wvc-sizes"
  }, {
    number: "HR-020",
    name: "Uszczelnienie hali przemysłowej",
    room: "Obiekty Przemysłowe",
    location: "Małopolska",
    year: "2023",
    span: "col-span-12 md:col-span-6",
    aspect: "aspect-[1/1]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/hala_przemyslowa_malopolska.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/hala_przemyslowa_malopolska.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/hala_przemyslowa_malopolska.png-wvc-sizes"
  }, {
    number: "HR-021",
    name: "Hydroizolacja tarasu",
    room: "Hydroizolacja Tarasów",
    location: "Opolskie",
    year: "2023",
    span: "col-span-12 md:col-span-6",
    aspect: "aspect-[4/3]",
    image: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/uszczelnianie.png?v=v9cam0o6l5",
    srcset: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/uszczelnianie.png?v=drnrh4fo7pl-wvc-srcset",
    sizes: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/uszczelnianie.png?v=g1niqltqqi-wvc-sizes"
  }, {
    number: "HR-022",
    name: "Naprawa przecieków dachowych",
    room: "Dachy Skośne",
    location: "Pszczyna",
    year: "2023",
    span: "col-span-12 md:col-span-4",
    aspect: "aspect-[3/4]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/roof_leak_repair_expert.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/roof_leak_repair_expert.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/roof_leak_repair_expert.png-wvc-sizes"
  }, {
    number: "HR-023",
    name: "Przygotowanie powierzchni",
    room: "Dachy Płaskie",
    location: "Czechy",
    year: "2023",
    span: "col-span-12 md:col-span-8",
    aspect: "aspect-[16/10]",
    image: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/przygotowanie.png?v=pr30a6lu1t",
    srcset: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/przygotowanie.png?v=rj10mdieszk-wvc-srcset",
    sizes: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/przygotowanie.png?v=zj7ng5k7crd-wvc-sizes"
  }];
  const spreadImage = {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/proces_natrysku_hydroizolacji.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/proces_natrysku_hydroizolacji.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/proces_natrysku_hydroizolacji.png-wvc-sizes",
    caption: "Precyzja w każdym milimetrze — bezspoinowa membrana poliuretanowa tworzy trwałą barierę ochronną, odporną na ekstremalne warunki atmosferyczne."
  };
  const projects2 = [{
    number: "HR-024",
    name: "Przygotowanie do hydroizolacja balkonu",
    room: "Hydroizolacja Tarasów",
    location: "Śląsk",
    year: "2022",
    span: "col-span-12 md:col-span-7",
    aspect: "aspect-[4/3]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/balkon_hydroizolacja_slask.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/balkon_hydroizolacja_slask.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/balkon_hydroizolacja_slask.png-wvc-sizes"
  }, {
    number: "HR-025",
    name: "Przygotowanie do renowacji dachu hali",
    room: "OBIEKTY PRZEMYSŁOWE · GLIWICE\xA0· 2022",
    location: "Pszczyna",
    year: "2022",
    span: "col-span-12 md:col-span-5",
    aspect: "aspect-[3/4]",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/renowacja_dachu_hali_professional.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/renowacja_dachu_hali_professional.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/renowacja_dachu_hali_professional.webp-wvc-sizes"
  }];
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="672" id="ewolucja-dachu-przed-i-po" className="dark bg-background text-foreground pt-[200px] pb-32 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div ref={headerRef} className={`grid grid-cols-12 gap-8 mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="col-span-12 md:col-span-9">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase mb-8" style={{
          color: "var(--chart-1)"
        }}>
            HydroRoof / Realizacje 2022—2024
          </p>
          <h1 className="text-foreground leading-[0.95] tracking-tight !font-extrabold !font-serif !text-left !text-6xl" style={{
          fontSize: "clamp(4rem, 9vw, 8rem)"
        }}>Renowacja dachu przed i po</h1>
          <p className="font-default text-muted-foreground text-xl md:text-2xl mt-8 max-w-2xl leading-relaxed">
            Zobacz, jak nasze bezspoinowe membrany natryskowe przywracają szczelność i trwałość dachom, eliminując przecieki bez konieczności kosztownej wymiany pokrycia.
          </p>
        </div>
        
      </div>

      <div className="border-y border-border mb-16 md:mb-24">
        <div className="overflow-x-auto scrollbar-hide -mx-6 md:mx-0">
          <div className="flex items-center gap-0 px-6 md:px-0 min-w-max md:min-w-0 md:flex-wrap">
            {filters.map((filter, i) => <div key={filter} data-index={i} className="flex items-center">
                <Button variant="ghost" onClick={() => setActiveFilter(filter)} className={`relative font-default text-sm tracking-wide py-6 px-5 h-auto rounded-none hover:bg-transparent hover:text-foreground transition-colors duration-300 ${activeFilter === filter ? "text-foreground" : "text-muted-foreground"}`}>
                  {filter}
                  <span className={`absolute bottom-4 left-5 right-5 h-px transition-all duration-300 ease-out ${activeFilter === filter ? "scale-x-100" : "scale-x-0"}`} style={{
                backgroundColor: "var(--chart-1)",
                transformOrigin: "left"
              }} />
                </Button>
                {i < filters.length - 1 && <span className="h-4 w-px bg-border" aria-hidden="true" />}
              </div>)}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-6 gap-y-20 md:gap-y-28 mb-24 md:mb-32">
        {projects.map((project, i) => <article key={project.number} data-index={i} className={`${project.span} group cursor-pointer`}>
            <div className={`relative overflow-hidden ${project.aspect}`}>
              <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.name} loading="lazy" decoding="async" className="w-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.04] !h-[550px] !opacity-[1] !text-[rgba(249,250,251,1)] shadow" />
              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <ArrowUpRight className="h-5 w-5" style={{
              color: "var(--chart-1)"
            }} strokeWidth={1.25} />
              </div>
            </div>
            <div className="mt-6 transition-opacity duration-500">
              <p className="font-mono text-[11px] tabular-nums tracking-wider mb-3" style={{
            color: "var(--chart-1)"
          }}>
                {project.number}
              </p>
              <h3 className="font-default font-semibold text-foreground text-2xl md:text-[1.5rem] leading-tight mb-3">
                {project.name}
              </h3>
              <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-muted-foreground">
                {project.room} · {project.location} · {project.year}
              </p>
            </div>
          </article>)}
      </div>

      <div className="mb-24 md:mb-32 -mx-6 md:-mx-12 lg:-mx-16">
        <div className="relative w-full aspect-[21/9] overflow-hidden">
          <img src={spreadImage.image} data-wvc-srcset={spreadImage.srcset} data-wvc-sizes={spreadImage.sizes} alt="Proces aplikacji membrany natryskowej" loading="lazy" decoding="async" className="w-full h-full object-cover" />
        </div>
        <div className="px-6 md:px-12 lg:px-16 mt-8">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 md:col-span-2">
              <p className="font-mono text-[11px] tracking-[0.2em] uppercase" style={{
              color: "var(--chart-1)"
            }}>
                Technologia
              </p>
            </div>
            <div className="col-span-12 md:col-span-8">
              <p className="font-default text-foreground text-xl md:text-2xl leading-relaxed">
                {spreadImage.caption}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-x-6 gap-y-20 md:gap-y-28 mb-24">
        {projects2.map((project, i) => <article key={project.number} data-index={i} className={`${project.span} group cursor-pointer`}>
            <div className={`relative overflow-hidden ${project.aspect}`}>
              <img src={project.image} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.04]" />
              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <ArrowUpRight className="h-5 w-5" style={{
              color: "var(--chart-1)"
            }} strokeWidth={1.25} />
              </div>
            </div>
            <div className="mt-6">
              <p className="font-mono text-[11px] tabular-nums tracking-wider mb-3" style={{
            color: "var(--chart-1)"
          }}>
                {project.number}
              </p>
              <h3 className="font-default font-semibold text-foreground text-2xl md:text-[1.5rem] leading-tight mb-3">
                {project.name}
              </h3>
              <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-muted-foreground">
                {project.room} · {project.location} · {project.year}
              </p>
            </div>
          </article>)}
      </div>

      
    </section>;
}